import { spacing } from "globalStyles";
import React from "react";
import styled from "styled-components";
import { breakpoints } from "themes/breakpoints";
import ListCard from "ui/List/Card";
import Cell from "ui/List/Cell";
import CardExtraInfo from "./CardExtraInfo";
import FeeCell from "ui/List/FeeCell";
import { GenericStreetSection, Street } from "interfaces/content";

export interface StreetProps {
  street: Street;
  cellConfig: GenericStreetSection["data"]["cellConfig"];
  className?: string;
}

const StreetCard = ({
  cellConfig,
  className,
  street: { collapsedInfo, ...street },
}: StreetProps) => {
  const parsedCells = Object.keys(street).map((key) => ({
    key,
    value: street[key],
  }));

  return (
    <ListCard
      ExtraInfo={<CardExtraInfo collapsedInfo={collapsedInfo} cellConfig={cellConfig} />}
      className={className}
    >
      <Container>
        {parsedCells &&
          parsedCells.length > 0 &&
          parsedCells.map((cell) => {
            if (Array.isArray(cell.value)) {
              if (!cell.value.length) return null;

              return (
                <FeeCell
                  key={`${cellConfig?.[cell.key]?.label}_${cell.value}`}
                  size={cellConfig?.[cell.key]?.size}
                  label={cellConfig?.[cell.key]?.label}
                  fees={cell.value}
                  className={cellConfig?.[cell.key]?.className}
                />
              );
            }

            return (
              <Cell
                key={`${cellConfig?.[cell.key]?.label}_${cell.value}`}
                size={cellConfig?.[cell.key]?.size}
                label={cellConfig?.[cell.key]?.label}
                value={cell.value}
                className={cellConfig?.[cell.key]?.className}
              />
            );
          })}
      </Container>
    </ListCard>
  );
};

export default StreetCard;

const Container = styled.div`
  display: flex;
  flex: 1;

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;

    .cell:not(:first-of-type) {
      margin-top: ${spacing.small}px;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    .cell:not(:first-of-type) {
      margin-top: ${spacing.extraSmall}px;
    }
  }
`;
